import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { api, list } from "@/lib/api";
import { Hero } from "@/components/site/Hero";
import { Bento } from "@/components/site/Bento";
import { HowItWorks } from "@/components/site/HowItWorks";
import { SoldWall } from "@/components/site/SoldWall";
import { Instagram } from "lucide-react";
import { RequestSection } from "@/components/site/RequestSection";
import { ProductCard } from "@/components/site/ProductCard";
import { Reveal, Eyebrow } from "@/components/site/Reveal";

const Latest = ({ products }) => {
  const avail = products.filter((p) => p.status !== "Sold");
  if (!avail.length) return null;
  return (
    <section className="mx-auto max-w-[1400px] px-5 py-28 md:px-10 md:py-36" data-testid="latest-section">
      <Reveal className="mb-14 flex items-end justify-between gap-6">
        <div>
          <Eyebrow>Just listed</Eyebrow>
          <h2 className="font-display mt-5 text-5xl text-[#f3eefc] md:text-6xl">The <span className="italic text-[#d8b4fe]">goods</span></h2>
        </div>
        <Link to="/shop" className="shrink-0 text-sm text-[#d8b4fe] underline-offset-8 hover:underline" data-testid="latest-view-all-link">Shop all →</Link>
      </Reveal>
      <div className="grid grid-cols-2 gap-x-4 gap-y-12 md:gap-x-6 lg:grid-cols-4">
        {avail.slice(0, 8).map((p, i) => (
          <Reveal key={p.id} delay={(i % 4) * 0.08}><ProductCard p={p} /></Reveal>
        ))}
      </div>
    </section>
  );
};

export default function Home() {
  const [products, setProducts] = useState([]);
  useEffect(() => {
    api.get("/products").then((r) => setProducts(list(r))).catch(() => setProducts([]));
  }, []);
  return (
    <>
      <Hero />
      <Bento products={products} />
      <HowItWorks />
      <SoldWall />
      <a href="https://www.instagram.com/shopmaisonpierre" target="_blank" rel="noreferrer" data-testid="instagram-follow-band" className="group block border-b border-[#281245] bg-[#0b0514]">
        <div className="mx-auto flex max-w-[1400px] flex-col items-start justify-between gap-6 px-5 py-14 md:flex-row md:items-center md:px-10">
          <div>
            <p className="font-mono-j text-xs uppercase tracking-[0.3em] text-[#c4a5f5]">Instagram</p>
            <h2 className="font-display mt-3 text-3xl leading-tight text-[#f3eefc] md:text-5xl">New drops hit Instagram first.</h2>
          </div>
          <span className="inline-flex items-center gap-3 rounded-full bg-[#f3eefc] px-7 py-4 text-sm font-medium text-[#07030c] transition-colors duration-300 group-hover:bg-[#d8b4fe]">
            <Instagram className="h-4 w-4" /> Follow @shopmaisonpierre
          </span>
        </div>
      </a>
      <Latest products={products} />
      <RequestSection />
    </>
  );
}
